export const TEXT_QUESTION = 'TextQuestion';
export const SECTION_HEADER = 'SectionHeader';
export const RADIOBUTTON_QUESTION = 'SingleSelectionRadioButtonQuestion';
export const BOOLEAN_QUESTION = 'BooleanQuestion';
export const NUMBER_QUESTION = 'NumberQuestion';
export const DATE_QUESTION = 'DateQuestion';
export const DROPDOWN_QUESTION = 'SingleSelectionDropdownQuestion';
export const CHECKBOX_QUESTION = 'MultiSelectionQuestion';
export const MATRIX_GROUPING = 'QuestionMatrixGrouping';
export const SLIDER_QUESTION = 'SliderQuestion';
